module.exports = __webpack_public_path__ + "img/button_OR-Text.193db8df.svg";